import React, { useEffect, useState, useContext } from 'react'
import { MainNavContext } from '@toasttab/shared/src/components/organisms/Navigation/Context/MainNavContext'
import classNames from 'classnames'
import {
  PhoneNumberLinkProps,
  MobileSalesIndicatorSchedule
} from '@toasttab/shared/src/interfaces/Navigation.d'

export const determinePhoneAvailability = (
  schedule: MobileSalesIndicatorSchedule[]
) => {
  // Get the current day of week & time of day in Eastern time zone
  const now = new Intl.DateTimeFormat('en-US', {
    weekday: 'long',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
    timeZone: 'America/New_York'
  }).format(new Date())
  const dayArr = now.split(' ')
  const dayOfWeek = dayArr[0]
  const currentTime = dayArr[1]

  // Get today's schedule for phone availability
  const todaySchedule: {
    enabled: boolean
    day: string
    endTime: string
    startTime: string
  } = schedule.find(
    (scheduleDay: { day: string }) => scheduleDay.day === dayOfWeek
  )
  // If phone support isn't enabled today, we can end here
  if (!todaySchedule.enabled) {
    return false
  }

  // Narrow the startTime and endTime strings down to just the actual time
  const todayStart = todaySchedule.startTime.substring(
    todaySchedule.startTime.lastIndexOf('T') + 1,
    todaySchedule.startTime.lastIndexOf('-')
  )
  const todayEnd = todaySchedule.endTime.substring(
    todaySchedule.endTime.lastIndexOf('T') + 1,
    todaySchedule.endTime.lastIndexOf('-')
  )

  // Return true if the current time is between today's start and end times
  if (todayStart < currentTime && currentTime < todayEnd) {
    return true
  }
  // If not, return false
  return false
}

const PhoneNumberLink = ({
  mobileSalesIndicatorSchedule,
  hideSalesIndicator
}: PhoneNumberLinkProps) => {
  let [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    if (mobileSalesIndicatorSchedule) {
      const isAvailable = determinePhoneAvailability(
        mobileSalesIndicatorSchedule
      )
      setShowBanner(isAvailable)
    }
  }, [])

  const { mobileNavOpen } = useContext(MainNavContext)

  const phoneNumberStyles = classNames(
    'relative text-base text-blue-75 pl-3 pr-6',
    {
      // Basic dot styling
      'after:content-[""] after:w-[10px] after:h-[10px] after:border-2 after:border-solid after:border-white after:rounded-full after:z-10 after:absolute after:top-1/2 after:left-0 after:-translate-y-1/2':
        mobileSalesIndicatorSchedule,
      // Coloring for the active/inactive dot
      'after:bg-grass-35': showBanner,
      'after:bg-gray-40': !showBanner,
      hidden: mobileNavOpen,
      'inline-block': !mobileNavOpen
    }
  )
  const bannerStyles = classNames(
    // Main banner
    'bg-grass-35 absolute top-[32px] rounded-base py-1.5 px-2 uppercase left-[24px] text-center text-sm text-white z-50',
    // Pointer
    'before:border-solid before:border-4 before:border-white before:border-b-[#93c75f] before:absolute before:bottom-[100%] before:left-[52px] before:content-[""] before:w-[10px] before:h-[10px] '
  )

  return (
    <a href='tel:6172971005' className={phoneNumberStyles}>
      Sales: (617) 297-1005
      {showBanner && !hideSalesIndicator && (
        <div className={bannerStyles}>
          <span>Now Available</span>
        </div>
      )}
    </a>
  )
}

export default PhoneNumberLink
